import { Flex, Grid, Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import EmptyCoach from "../../../../assets/images/content/empty_coach.png";
import MapPinFilled from "../../../../assets/images/icons/MapPinFilled";
import Ski from "../../../../assets/images/icons/Ski";
import { CoachResponse } from "../../../../hooks/Coach/data";
import { pushGtag } from "../../../../plugins/utils";
import { H5, P1 } from "../../../NormalFonts";
import styles from "./styles.module.scss";

const CoachItem = ({ data }: { data: CoachResponse }) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickCoach = (id: number) => {
    pushGtag({
      event: "view_coach",
      info: data,
    });

    navigate(`/trainers/info/${id}`);
  };

  const getNameSize = () => {
    if (screens.md) return "28px";
    if (screens.sm) return "20px";
    return "16px"; // Default for xs or smaller
  };
  const getImageMargin = () => {
    if (screens.md) return "20px";
    if (screens.sm) return "16px";
    return "8px"; // Default for xs or smaller
  };

  return (
    <div
      className={`${styles.coachItem} ${screens.md ? "" : styles.mobile}`}
      onClick={() => handleClickCoach(data.account_id)}
    >
      <Image
        width={"100%"}
        preview={false}
        src={data.profile_url}
        alt={data.nickname}
        className={styles.profile}
        fallback={EmptyCoach}
        style={{ marginBottom: getImageMargin() }}
      />
      <H5
        weight="heavy"
        color="var(--primary)"
        className={styles.nickname}
        style={{ fontSize: getNameSize() }}
      >
        {data.nickname}
      </H5>
      <Flex gap={8} className={styles.skiResort}>
        <MapPinFilled
          style={{
            minWidth: screens.md ? 20 : 14,
            minHeight: screens.md ? 20 : 14,
            color: "##06304D",
            marginTop: screens.md ? 2 : 3,
          }}
        />
        <P1 className={styles.desc} weight="normal" color="var(--primary-90)">
          {data?.ski_resort_codes && data?.ski_resort_codes?.length > 0
            ? data.ski_resort_codes
                .map((skiResort: string) => t(`skiresort.${skiResort}`))
                .join(" / ")
            : t("normal.empty")}
        </P1>
      </Flex>
      <Flex gap={8}>
        <Ski
          style={{
            fontSize: screens.md ? 20 : 14,
            color: "#06304D",
            marginTop: screens.md ? 1 : 2,
          }}
        />
        <P1 className={styles.desc} weight="normal" color="var(--primary-90)">
          {data?.skill_codes && data?.skill_codes.length > 0
            ? data.skill_codes
                .map((skill: string) => t(`normal.skill.${skill}`))
                .join(" / ")
            : t("normal.empty")}
        </P1>
      </Flex>
    </div>
  );
};

export default CoachItem;
